/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_InformationInputs */



/**
* | output |
* | --- |
* | "Contact Information" |
*
* @param {Contact_InformationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const contact_information = /** @type {((inputs?: Contact_InformationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_InformationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Informations de contact")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontaktinformationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni sui contatti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контактная информация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Información del contacto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("联系信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("連絡先")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपर्क जानकारी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Informações de contato")
	return /** @type {LocalizedString} */ ("Contact Information")
});